export { spaceRemover } from './spaceRemover'
export { urlValue } from './url'
export { projectContext, ProjectProvider } from './projectContext'
export { loadingContext, LoadingProvider } from './loadingContext'
export { intentsContext, IntentsProvider } from './intentsContext'
export { TranslationProvider, useTranslate } from './translationContext';
export { validContext, ValidProvider } from './validContext'
export { msalConfig, loginRequest } from './authConfig'
export { unfolder, encrypter, generateAndRegisterToken } from './CryptoMethods'
export {getCookie, setCookie, eraseCookie} from './CookiesMethod'
export {onImportExcelAsync,downloadFile, downloadFileNew} from './ImportExcel'
export {animateCSS, openModalVw, closeModalVw, safeCloseModalVw, openAlert, closeAlert} from './AnimationsCss'


export function groupBy(array, key) {
    return array.reduce((result, currentItem) => {
        
        const groupKey = currentItem[key];
 
        if (!result[groupKey]) {
            result[groupKey] = [];
        } 
         
        result[groupKey].push(currentItem);

        return result;
    }, {});
}